/*
 * useWindowSize - this hook is used attach to the component a resize event,
*  in order to be able to understand if the component has to render mobile or desktop view
 */

import { useState, useEffect } from 'react';

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
      });

      useEffect(() => {
        function handleResize() {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }
        
        window.addEventListener("resize", handleResize);
        
        handleResize();
        
        return () => window.removeEventListener("resize", handleResize);
      }, []); 
      return windowSize;
}

export default useWindowSize;